import * as React from 'react';
import { WPBlockProps } from './types';
import { getWpBlock } from './index';

export default function WpGroup({
  block,
  parentLength,
}: WPBlockProps): JSX.Element | null {
  const classDef =
    'group-content ' + parentLength ? 'col-count-' + parentLength : '';
  //const innerblockLength = block.innerBlocks.length;
  return (
    <div className={classDef}>
      {block.innerBlocks.map((innerCol) => {
        const InnerWpBlock = getWpBlock(innerCol.__typename);
        if (!InnerWpBlock || !innerCol.databaseId) return null;
        return <InnerWpBlock key={innerCol.databaseId} block={innerCol} />;
      })}
    </div>
  );
}
